import store from '@/store'
import transverser from '@/helpers/transverser'
import auth from '@/auth'
import { createAuthRequestNew, isAuthenticated, isExternalyAuthenticated } from '@/auth/token'

/**
 * Returns whether is public route
 * @param {*} route  Current route
 * @return {Boolean} true is route is flag as public, false in other case
 */
const isPublicRoute = (route = {}) =>
  transverser.get('meta.isPublic', false)(route)

/**
 * Solo tiene login a través del API de Login
 */
export default (to, from, next) => {
  if (isPublicRoute(to)) return next()
  if (isExternalyAuthenticated(to.params.token)) return next()

  if (isAuthenticated()) {
    // Es un fix para el portal de soporte
    if (to.path && (to.path === '/login' || to.path === '/eurobits/login')) {
      return next({ name: 'login' })
    } else {
      return next()
    }
  }

  // TODO: Quitar y implementar esta logica en el componente del login y a partir del servicio correcto.
  // Esta implementación solo tiene sentido para bankia.
  let authorizationBody = createAuthRequestNew(to.params)

  if (!authorizationBody) return next({ name: 'login' })

  auth.authenticateNew(authorizationBody)
  .then(() => {
    store.dispatch('errors/empty')
    return next()
  }, () => {
    return next({
      name: 'login'
    })
  })
}
